import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const getWpContent = (url) => {
  return new Promise((resolve, reject) => {
    axios.get(url)
    .then(response => {
      resolve(response.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

export default new Vuex.Store({
  state: {
    config: {
      baseurl: 'https://especiales.latercera.com/transicion',
      title: 'Transición',
      description: 'Chile recién comienza a entender y aceptar a las personas transgénero. ¿Cómo es transicionar y vivir siendo trans en nuestro país?',
      hashtag: '#transicionlt',
      brandtitle: 'Presentado por Wom',
      reporttitle: 'Especial Transición La Tercera',
      img: '/content/share.jpg',
      slug: '/',
      modal: false,
      gallery: false,
      moving: false,
      menu: false,
      lab: {
        logo: 'assets/images/logos/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: 'http://www.laboratoriodecontenidos.cl',
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/quepasa.svg',
        title: 'Qué Pasa',
        url: {
          name: "home"
        },
        height: '40'
      },
      sponsor: {
        logo: 'assets/images/logo-wom.svg',
        title: 'wom',
        url: {
          name: "home"
        },
        height: '50'
      },
      home: {
        video: '<iframe width="560" height="315" src="https://www.youtube.com/embed/fgUqmUVdQVc?controls=0&autoplay=1&enablejsapi=1&modestbranding=1&playsinline=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      }
    },
    podcast: {
      opened: false,
      running: false,
      url: '',
      title: '',
      artist: 'Radio Zero'
    },
    credits:[
      {
        'role': 'Creación y coordinación del proyecto, investigación, guiones y textos',
        'persons': [
          'Tania Opazo'
        ]
      },
      {
        'role': 'Grabaciones y montaje audiovisual',
        'persons': [
          'Catalina Jaque',
          'Alex Utreras'
        ],
      },
      {
        'role': 'Fotos',
        'persons': [
          'Juan Farías',
          'Rudy Muñoz',
          'Patricio Fuentes',
          'Reinaldo Ubilla'
        ],
      },
      {
        'role': 'Infografías',
        'persons': [
          'Hilda Oliva',
          'Álvaro Stuardo',
          'Rodrigo Valenzuela',
          'Heglar Fleming'
        ],
      },
      {
        'role': 'Podcasts',
        'persons': [
          'Tania Opazo',
          'Sergio Fortuño (Radio Zero)',
          'Tania Selaive (Radio Zero)'
        ]
      },
      {
        'role': 'Desarrollo web',
        'persons': [
          'Álex Acuña Viera'
        ]
      },
      {
        'role': 'Diseño',
        'persons': [
          'Felipe de la Fuente',
          'Sandro Baeza'
        ],
      },
      {
        'role': 'Entrevista Wom',
        'persons': [
          'Belén Peña',
        ],
      },
    ],
    sections: [
      {
        title: 'Mi Transición',
        slug: '/mi-transicion',
        undertitle: '',
        downtitle: '¿Cómo es vivir siendo transgénero en Chile? Seis personas comparten sus historias y experiencias de transición.',
        innertitle: 'Chile recién comienza a entender y aceptar a las personas transgénero. ¿Cómo es transicionar y vivir siendo trans en nuestro país? Un hombre trans, una mujer trans, un trans no binario, una adolescente trans, un niño trans y una adulta mayor trans comparten sus historias en este especial, abriendo una ventana a la realidad de esta comunidad.',
        img: 'content/mi-transicion.jpg',
        shareimg: '/content/sharers/share-ambar.jpg',
        inhome: false,
        looper: true
      },
      {
        title: 'Ciencia Trans',
        slug: '/ciencia-trans',
        undertitle: '',
        downtitle: 'Un espacio de educación y reflexión, tanto desde las ciencias biológicas como sociales, al fenómeno de la transgeneridad.',
        img: 'content/ciencia-trans.jpg',
        shareimg: '/content/sharers/share-ciencia-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/154',
        inhome: true
      },
      {
        title: 'Salud Trans',
        slug: '/salud-trans',
        undertitle: '',
        downtitle: 'El debate por la patologización, los problemas médicos que deben enfrentar las personas trans y los tratamientos disponibles.',
        img: 'content/salud-trans.jpg',
        shareimg: '/content/sharers/share-salud-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/156',
        inhome: true
      },
      {
        title: 'Chile Trans',
        slug: '/chile-trans',
        undertitle: '',
        downtitle: 'Los movimientos sociales, los logros y las batallas pendientes. Revisamos el pasado, presente y futuro de la comunidad trans en Chile.',
        img: 'content/chile-trans.jpg',
        shareimg: '/content/sharers/share-chile-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/158',
        inhome: true
      },
      {
        title: 'Infancia Trans',
        slug: '/infancia-trans',
        undertitle: '',
        downtitle: 'Los pequeños que tensionaron el debate y pusieron la transgeneridad en el ojo público. Una generación que está escribiendo una nueva forma de ser trans.',
        img: 'content/infancia-trans.jpg',
        shareimg: '/content/sharers/share-infancia-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/224',
        inhome: true
      },
      {
        title: 'Avance Trans',
        slug: '/avance-trans',
        undertitle: '',
        downtitle: 'Los avances en los derechos de las personas transgénero en nuestro país hasta la recién aprobada Ley de Identidad de Género (LIG)',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/15',
        inhome: true
      },
      {
        title: 'Lenguaje Inclusivo',
        slug: '/la-lengua-muy-bien-gracias',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/369',
        inhome: false
      },
      {
        title: 'Activista',
        slug: '/activista',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/365',
        inhome: false
      },
      {
        title: 'Derecho a las Identidades',
        slug: '/el-derecho-a-las-identidades-sexuales',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/363',
        inhome: false
      },
      {
        title: 'Experiencias Trans',
        slug: '/experiencias-trans',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/373',
        inhome: false
      },
      {
        title: 'Transcripción Podcast Salud',
        slug: '/podcast-salud',
        undertitle: '',
        downtitle: '',
        img: 'content/salud-trans.jpg',
        shareimg: '/content/sharers/share-salud-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/1163',
        inhome: false
      },
      {
        title: 'Transcripción Podcast LIG',
        slug: '/podcast-lig',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/1165',
        inhome: false
      },
    ],
    articles: [
      {
        title: 'Martín',
        undertitle: 'Con 30 años, Martín lleva casi nueve meses de tratamiento hormonal para hacer su tránsito de género. A pesar de cierta resistencia por parte de su familia él está feliz: siente que finalmente comenzó a vivir.',
        credits: '<p>Por: <strong>Tania Opazo</strong></p><p>Fotos: <strong>Juan Farías</strong></p><p>Videos: <strong>Catalina Jaque</strong></p>',
        img: 'content/mi-transicion/martin.jpg',
        imgsmall: 'content/mi-transicion/martin-small.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/76',
        slug: 'martin',
        share: {
          title: 'Martín',
          description: 'Con 30 años, Martín lleva casi nueve meses de tratamiento hormonal para hacer su tránsito de género. A pesar de cierta resistencia por parte de su familia él está feliz: siente que finalmente comenzó a vivir.',
          img: '/content/sharers/share-martin.jpg'
        }
      },
      {
        title: 'Ámbar',
        undertitle: 'Ámbar soñó desde pequeña con llevar vestidos, maquillajes y zapatos de taco alto. Intentó reprimirlo, ser el "macho" que algunos esperaban, hasta que un día aceptó que se sentía, y era, una mujer.',
        credits: '<p>Por: <strong>Tania Opazo</strong></p><p>Fotos: <strong>Juan Farías</strong></p><p>Videos: <strong>Catalina Jaque</strong></p>',
        img: 'content/mi-transicion/ambar.jpg',
        imgsmall: 'content/mi-transicion/ambar-small.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/7',
        slug: 'ambar',
        share: {
          title: 'Ámbar',
          description: 'Ámbar soñó desde pequeña con llevar vestidos, maquillajes y zapatos de taco alto. Intentó reprimirlo, ser el "macho" que algunos esperaban, hasta que un día aceptó que se sentía, y era, una mujer.',
          img: '/content/sharers/share-ambar.jpg'
        }
      },
      {
        title: 'Francis',
        undertitle: 'Tiene sólo 20 años pero Francis ha recorrido un largo camino para atraverse a decir que no quiere ser catalogado ni como hombre ni como mujer. Gracias al apoyo de su papá y hermano hoy se define como de género no binarie.',
        credits: '<p>Por: <strong>Tania Opazo</strong></p><p>Fotos: <strong>Juan Farías</strong></p><p>Videos: <strong>Catalina Jaque</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/148',
        img: 'content/mi-transicion/fran.jpg',
        imgsmall: 'content/mi-transicion/fran-small.jpg',
        slug: 'francis',
        share: {
          title: 'Francis',
          description: 'Tiene sólo 20 años pero Francis ha recorrido un largo camino para atraverse a decir que no quiere ser catalogado ni como hombre ni como mujer. Gracias al apoyo de su papá y hermano hoy se define como de género no binarie.',
          img: '/content/sharers/share-francis.jpg'
        }
      },
      {
        title: 'Ángela',
        undertitle: 'De modos suaves y voz calmada, Ángela nunca se sintió cómoda entre los gritos y pelotazos de sus compañeros de colegio. Hoy disfruta llevar faldas y bailar k-pop, como cualquier adolescente. Como la chica que siempre fue.',
        credits: '<p>Por: <strong>Tania Opazo</strong></p><p>Fotos: <strong>Juan Farías</strong></p><p>Videos: <strong>Catalina Jaque, Álex Utreras</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/239',
        img: 'content/mi-transicion/angela.jpg',
        imgsmall: 'content/mi-transicion/angela-small.jpg',
        slug: 'angela',
        share: {
          title: 'Ángela',
          description: 'De modos suaves y voz calmada, Ángela nunca se sintió cómoda entre los gritos y pelotazos de sus compañeros de colegio. Hoy disfruta llevar faldas y bailar k-pop, como cualquier adolescente. Como la chica que siempre fue.',
          img: '/content/sharers/share-angela.jpg'
        }
      },
      {
        title: 'Alexis',
        undertitle: 'Tenía apenas tres años y Alexis le decía a su mamá que no quería peinarse con cachos ni ponerse ropa rosada. A pesar de las dudas, sus papás lo apoyaron. Él ya tiene seis y explica con naturalidad que es transgénero.',
        credits: '<p>Por: <strong>Tania Opazo</strong></p><p>Fotos: <strong>Juan Farías</strong></p><p>Videos: <strong>Catalina Jaque, Álex Utreras</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/241',
        img: 'content/mi-transicion/alexis.jpg',
        imgsmall: 'content/mi-transicion/alexis-small.jpg',
        slug: 'alexis',
        share: {
          title: 'Alexis',
          description: 'Tenía apenas tres años y Alexis le decía a su mamá que no quería peinarse con cachos ni ponerse ropa rosada. A pesar de las dudas, sus papás lo apoyaron. Él ya tiene seis y explica con naturalidad que es transgénero.',
          img: '/content/sharers/share-alexis.jpg'
        }
      },
      {
        title: 'Katty',
        undertitle: 'Katty dejó su casa siendo una niña y empezó a vivir en la calle cuando todavía no cumplía la mayoría de edad. Dice que es sobreviviente de una generación que jamás escuchó la palabra trans y que vivió la discriminación más dura.',
        credits: '<p>Por: <strong>Tania Opazo</strong></p><p>Fotos: <strong>Juan Farías</strong></p><p>Videos: <strong>Catalina Jaque, Álex Utreras</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/243',
        img: 'content/mi-transicion/katty.jpg',
        imgsmall: 'content/mi-transicion/katty-small.jpg',
        slug: 'katty',
        share: {
          title: 'Katty',
          description: 'Katty dejó su casa siendo una niña y empezó a vivir en la calle cuando todavía no cumplía la mayoría de edad. Dice que es sobreviviente de una generación que jamás escuchó la palabra trans y que vivió la discriminación más dura.',
          img: '/content/sharers/share-katty.jpg'
        }
      },
      {
        title: 'Amparo',
        undertitle: 'Como forma de mostrar su apoyo a la diversidad de género, Wom auspicia este especial de Transición y comparte la integración de Amparo, la cual es parte del equipo.',
        credits: '<p>Por: <strong>Belén Peña L.</strong></p><p>Videos: <strong>Álex Utreras</strong></p>',
        wom: true,
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/566',
        img: 'content/mi-transicion/amparo.jpg',
        imgsmall: 'content/mi-transicion/amparo-small.jpg',
        slug: 'amparo',
        share: {
          title: 'Amparo',
          description: 'Como una forma de mostrar su apoyo a las diversidades de género, Wom auspicia el especial Transición y comparte la historia de integración de Amparo, quien es parte de su equipo de trabajo.',
          img: '/content/sharers/share-amparo.jpg'
        }
      },
    ],
    timeline: [
      {
        year: 1973,
        milestones: [
          {
            text: 'Primera manifestación de travestis en la Plaza de Armas de Santiago.',
            img: 'content/1973.jpg',
            url: ''
          },
          {
            text: 'Primera cirugía de modificación genital realizada en Chile.',
            img: '',
            url: 'https://www.latercera.com/tendencias/noticia/la-revolucion-marcia-alejandra/132019/'
          }
        ],
      },
      {
        year: 1974,
        milestones: [
          {
            text: 'Primer cambio de nombre y sexo registral en Chile acogiéndose a la ley 17.344.',
            img: '',
            url: 'https://www.latercera.com/tendencias/noticia/la-revolucion-marcia-alejandra/132019/'
          }
        ]
      },
      {
        year: 1988,
        milestones: [
          {
            text: 'Las Yeguas del Apocalipsis, colectivo artístico conformado por Pedro Lemebel y Francisco Casas, realizan su primera intervención pública.La temática trans y homosexual cruza las perfomances realizadas por el dúo.',
            url: '',
            img: 'content/1988.jpg',
          }
        ]
      },
      {
        year: 1999,
        milestones: [
          {
            text: 'Primera Marcha por la Diversidad.',
            img: 'content/1999.jpg',
            url: ''
          }
        ]
      },
      {
        year: 2011,
        milestones: [
          {
            text: 'Publicación de la Vía Clínica del Ministerio de Salud, una guía técnica que contiene criterios para regular el tránsito sicológico y físico de una persona trans.',
            img: '',
            url: 'content/2011-4-via-clinica-minsal.pdf'
          },
          {
            text: 'Circular 34 del Ministerio de Salud regula el uso obligatorio del nombre social de las personas trans en la ficha clínica.',
            img: '',
            url: 'content/2011-5-circular-34-21.pdf'
          }
        ]
      },
      {
        year: 2012,
        milestones: [
          {
            text: 'Se dicta la ley 20.609, conocida como Ley Zamudio, que establece la identidad de género como categoría sospechosa de discriminación.',
            img: '',
            url: 'https://www.bcn.cl/leyfacil/recurso/ley-de-no-discriminacion'
          }
        ]
      },
      {
        year: 2013,
        milestones: [
          {
            text: 'Se ingresa al Senado el proyecto de ley que reconoce y da protección al derecho a la identidad de género.',
            img: '',
            url: 'http://www.senado.cl/appsenado/templates/tramitacion/index.php?boletin_ini=8924-07'
          }
        ]
      },
      {
        year: 2014,
        milestones: [
          {
            text: 'Fallece Hija de Perra (Víctor Pérez), transformista y artista escénica que destacó como activista social por los derechos de las mujeres y minorías sexuales.',
            img: 'content/2014-6-hija.jpg',
            url: ''
          }
        ]
      },
      {
        year: 2015,
        milestones: [
          {
            text: 'Se realiza el primer Trans Fest, Festival por la Despatologización de las Identidades Trans.',
            img: 'content/2015-7-transfest.jpg',
            url: ''
          },
          {
            text: 'Circular 18 del Ministerio de Salud instruye detener tratamientos innecesarios de "normalización" para niñes intersex, incluyendo cirugías genitales irreversibles, hasta que tengan edad suficiente para decidir sobre sus cuerpos',
            img: '',
            url: 'content/2015-8-circular-18.pdf'
          }
        ]
      },
      {
        year: 2017,
        milestones: [
          {
            text: 'Primera audiencia temática de la Comisión Interamericana de Derechos Humanos sobre la situación de los derechos humanos de las personas trans en Chile.',
            img: 'content/2017-9-comision.jpg',
            url: 'https://www.youtube.com/watch?v=CW-O4uPT3vI'
          },
          {
            text: 'Circular de la Superintendencia de Educación dictamina que los colegios deben respetar la identidad y expresión de género de los estudiantes trans.',
            img: '',
            url: 'content/2017-10-mineducacion.pdf'
          },
          {
            text: 'Ministerio de Educación lanza el documento: Orientaciones para la inclusión de las personas lesbianas,, gays, bisexuales, trans e intersex',
            img: '',
            url: 'content/2017-11-ministerio.pdf'
          },
          {
            text: 'Corte Suprema acoge por primera vez una acción de no discriminación por identidad de género, el caso de la Alejandra González, ex concejala de Lampa.',
            img: '',
            url: 'http://www2.latercera.com/noticia/corte-suprema-acoge-demanda-discriminacion-concejala-transgenero/'
          },
          {
            text: 'Dictamen de la Inspección del Trabajo señala que es deber del empleador respetar la identidad de género autopercibida y facilitarle acceso al servicio higiénico correspondiente a esa identidad.',
            img: '',
            url: 'content/2017-11-inspeccion.pdf'
          }
        ]
      },
      {
        year: 2018,
        milestones: [
          {
            text: 'La película Una mujer fantástica gana el Oscar a mejor película extranjera',
            img: 'content/2018-12-mujerfantastica.jpg',
            url: ''
          },
          {
            text: 'La Corte Suprema dicta por primera vez sentencia respecto a una solicitud de cambio de nombre y sexo registral, acogiendo el recurso sin exigir una intervención quirúrgica para ello.',
            img: '',
            url: 'https://www.latercera.com/politica/noticia/suprema-cita-tratados-internacionales-acoger-cambio-sexo-registral-mujer-trans/186549/'
          },
          {
            text: 'Aprobación de la Ley de Identidad de Género por el Congreso.',
            img: 'content/2018-13-aprobacion.jpg',
            url: 'https://www.latercera.com/politica/noticia/camara-diputados-aprueba-ley-identidad-genero-95-votos-favor-46/317686/'
          }
        ]
      }
    ]
  },
  mutations: {
    SET_PODCAST: (state, payload) => {
      state.podcast = {
        opened: true,
        running: true,
        url: payload.url,
        title: payload.title,
        artist: payload.artist || 'Radio Zero'
      }
    },
    CLOSE_PODCAST: (state) => {
      state.podcast.opened = false
    },
    SET_CONTENT: (state, payload) => {
      state.articles[payload.index].content = payload.content;
    },
    SET_SECTION_CONTENT: (state, payload) => {
      state.sections[payload.index].content = payload.content;
    },
    TOGGLE_MODAL: (state) => {
      state.config.modal = !state.config.modal
    },
    TOGGLE_MENU: (state) => {
      state.config.menu = !state.config.menu
    },
    TOGGLE_GALLERY: (state) => {
      state.config.gallery = !state.config.gallery
    },
    SET_MOVING: (state, payload) => {
      state.config.moving = payload
    }
  },
  actions: {
    setPodcast (context, payload) {
      context.commit('SET_PODCAST', payload)
    },
    closePodcast(context) {
      context.commit('CLOSE_PODCAST')
    },
    setMoving (context, payload) {
      context.commit('SET_MOVING', payload)
    },
    toggleModal (context) {
      context.commit('TOGGLE_MODAL')
    },
    toggleMenu(context) {

      context.commit('TOGGLE_MENU')
    },
    toggleGallery(context) {
      context.commit('TOGGLE_GALLERY')
    },
    setContent: async(context, payload) => {
      try {
        const postcontent = await getWpContent(payload.url)
        const articleIndex = context.getters.getArticleIndex(payload.slug)
        return context.commit('SET_CONTENT', {
          content: postcontent.raw,
          index: articleIndex
        })
      } catch (error) {
        throw error
      }
    },
    setSectionContent: async (context, payload) => {
      try {
        const sectioncontent = await getWpContent(payload.url)
        const sectionIndex = context.getters.getSectionIndex(payload.slug)
        return context.commit('SET_SECTION_CONTENT', {
          content: sectioncontent.raw,
          index: sectionIndex
        })
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    getArticle: (state) => (slug) => {
      const articlearr = state.articles.filter(i => i.slug === slug)
      return articlearr[0]
    },
    getArticleIndex: (state) => (slug) => {
      const articleIndex = state.articles.findIndex(i => i.slug === slug)
      return articleIndex
    },
    getSection: (state) => (slug) => {
      const sectionarr = state.sections.filter(i => i.slug === slug)
      return sectionarr[0]
    },
    getSectionIndex: (state) => (slug) => {
      const sectionIndex = state.sections.findIndex(i => i.slug === slug)
      return sectionIndex
    },
  }
})
